/**
 * HHT1 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT1_EP14_ANSWERS = [
    'Everyone in class has studied hard all morning. They want to play a game.',
    'The teacher suggests playing “Hot and Cold.”',
    'The kids are happy, and eventually everyone agrees that Tony can be “it.”',
    'Tony leaves the classroom, and the teacher hides a key under the beetle’s house.',
    'Tony comes back into the classroom and tries to find the key.',
    'He asks his classmates whether he is hot or cold. But he is far from the key. The classmates say that he’s cold.',
    'Eventually, Tony is near the beetle house. The classmates tell Tony he’s really hot, he’s burning up! ',
    'Tony thinks he knows where the key is. He puts his hand into the beetle’s house. ',
    'Tony grabs a beetle instead of the key. The beetle bites! Tony thinks he’s lost his finger. ',
    'The school beetles are happily playing “Hot and Cold.” Suddenly, Tony’s huge hand comes into their home.',
    'Tony’s hand picks up the beetle who is “it.”',
    'The beetle screams and bites Tony’s finger. Tony screams and flings the beetle into the classroom. ',
    'The beetle flies away. Some kids hide, while some kids try to chase the beetle. It’s chaos!',
];

// export const HHT1_EP14_ANSWER_SOUNDS = [
//     '/1_EP14_SB_TL_01.mp3',
//     '/1_EP14_SB_TL_02.mp3',
//     '/1_EP14_SB_TL_03.mp3',
//     '/1_EP14_SB_TL_04 re.mp3',
//     '/1_EP14_SB_TL_05.mp3',
//     '/1_EP14_SB_TL_06.mp3',
//     '/1_EP14_SB_TL_07 re.mp3',
//     '/1_EP14_SB_TL_08 re.mp3',
//     '/1_EP14_SB_TL_09.mp3',
//     '/1_EP14_SB_TL_10.mp3',
//     '/1_EP14_SB_TL_11.mp3',
//     '/1_EP14_SB_TL_12.mp3',
//     '/1_EP14_SB_TL_13.mp3',
// ];

export const HHT1_EP14_ANSWER_SOUNDS = [
    '/57eab2b99db37938f843670c02b82595.mp3',
    '/031b8d908100d057e8a8650c995d15bc.mp3',
    '/f195432eecdd786660be3e9e886a0a71.mp3',
    '/41af8f8dabde3d791555457a807107b3.mp3',
    '/5a55a8f3b3ef60354757e049e6f3f8ab.mp3',
    '/105c0d1584d6be5925dc81e40df69a3a.mp3',
    '/6ae665342de8fd564937ab33acbc9fc6.mp3',
    '/7b0e354764ffaf4b181ba946765e8aa6.mp3',
    '/11f7c1d9e4314bdf0de692142aca227e.mp3',
    '/0d651858f0f47a255d35909d4df287b8.mp3',
    '/8776a50b9dfe29fc9e2233b71f6fa095.mp3',
    '/50dbdefecb886e9dd26002c90fbe4c45.mp3',
    '/e79105decfafb291932850cfb4f51852.mp3',
];

export const HHT1_EP14_QUIZ_ITEMS = [{
    'A': HHT1_EP14_ANSWERS[10],
    'B': HHT1_EP14_ANSWERS[1],
    'SoundIndexA': 10,
    'SoundIndexB': 1,
    'answer': HHT1_EP14_ANSWERS[1],
    'sound': [2],
    'exception': false,
},
    {
        'A': HHT1_EP14_ANSWERS[12],
        'B': HHT1_EP14_ANSWERS[3],
        'SoundIndexA': 12,
        'SoundIndexB': 3,
        'answer': HHT1_EP14_ANSWERS[3],
        'sound': [4],
        'exception': false,
    },
    {
        'A': HHT1_EP14_ANSWERS[5],
        'B': HHT1_EP14_ANSWERS[0],
        'SoundIndexA': 5,
        'SoundIndexB': 0,
        'answer': HHT1_EP14_ANSWERS[5],
        'sound': [6, 7],
        'exception': false,
    },
    {
        'A': HHT1_EP14_ANSWERS[8],
        'B': HHT1_EP14_ANSWERS[2],
        'SoundIndexA': 8,
        'SoundIndexB': 2,
        'answer': HHT1_EP14_ANSWERS[8],
        'sound': [9, 10],
        'exception': true,
    },
    {
        'A': HHT1_EP14_ANSWERS[4],
        'B': HHT1_EP14_ANSWERS[11],
        'SoundIndexA': 4,
        'SoundIndexB': 11,
        'answer': HHT1_EP14_ANSWERS[11],
        'sound': [12],
        'exception': false,
    },

]
